/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "#{Sitecore.JssApiKey}",
  "sitecoreApiHost": "",
  "jssAppName": "corporate",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/corporate",
  "graphQLEndpoint": "/api/corporate?sc_apikey=#{Sitecore.JssApiKey}"
};